import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
export default function Resources(props: _Navigation.SideNavJSXItemProps) {
  return (
    <Anchor
      class={props.anchor?.class}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      components={{
        title: "Resources",
        idleIcon: <i class="i-solar:folder-open-linear" />,
        activeIcon: <i class="i-solar:folder-open-linear" />,
      }}
    />
  );
}
